import { render, staticRenderFns } from "./BlockType3Grid.vue?vue&type=template&id=55de3b10&scoped=true&"
import script from "./BlockType3Grid.vue?vue&type=script&lang=ts&"
export * from "./BlockType3Grid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType3Grid.vue?vue&type=style&index=0&id=55de3b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de3b10",
  null
  
)

export default component.exports